import {useState} from 'react'
import {Menu as UikitMenu, NoticeBanner, useNoticeBanner, updateNoticeBanner} from '@pancakeswap/uikit'
import {languageList} from '~/config/localization/languages'
import {useTranslation} from '~/contexts/Localization'
import useTheme from '~/hooks/useTheme'
import useActiveWeb3React from '~/hooks/useActiveWeb3React'

import UserMenu from './UserMenu'
import GlobalSettings from './GlobalSettings'
import {getActiveMenuItem, getActiveSubMenuItem} from './utils'
import {footerLinks} from './config/footerConfig'
import fantomConfig from './config/chains/fantomConfig'
import defaultConfig from './config/chains/defaultConfig'
import stardustConfig from './config/chains/stardustConfig'
import {NoticeBarValues} from './config/noticeBarConfig'

import useSwitchNetworkCustom from "~/hooks/useSelectNetworkCustom";
import {useNetwork} from "wagmi";
import {AVAILABLE_NETWORKS} from "~/config/constants/chains";
import {useAppMode} from "~/state/app/useAppMode";


const Menu = (props: any) => {
  // const {chainId} = useActiveWeb3React()
  const {chain} = useNetwork()
  const {account} = useActiveWeb3React()
  const {appMode} = useAppMode()
  const {isDark, toggleTheme} = useTheme()
  // const cakePriceUsd = useCakeBusdPrice()  // Legacy: usePriceCakeBusd()
  // const cakePriceUsd = useCakeBusdPrice()  // Legacy: usePriceCakeBusd()
  // const mlumPriceUsd = useMLUMBusdPrice()
  // const smrPriceUsd = useSMRBusdPrice()

  // const SMR = toToken(chain.id, chainTokens.smr)
  // const LUM = toToken(chain.id, chainTokens.lum)
  // const magicLUM = toToken(chain.id, chainTokens.magicLum)

  const {switchNetwork} = useSwitchNetworkCustom()

  const {currentLanguage, setLanguage, t} = useTranslation()
  // const { pathname } = useLocation()

  // load menu links according to chain
  let menuConfig = account ? fantomConfig : defaultConfig
  // menuConfig = fantomConfig
  // if (chainId === CHAIN_ID.FANTOM_TESTNET) {
  // } else if (chainId === CHAIN_ID.SHIMMER) {
  //   menuConfig = stardustConfig
  // }

  const {menuConfig: config, showMLUM, showLUM, showSMR} = menuConfig
  // const { isXl } = useMatchBreakpoints()
  // const activeMenuItem = getActiveMenuItem({ menuConfig: config(t), pathname })
  // const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })
  // const cakePriceNumber = parseFloat(cakePriceUsd?.toFixed(3))
  // const mlumPriceNumber = parseFloat(mlumPriceUsd?.toFixed(3))
  // const smrPriceNumber = parseFloat(smrPriceUsd?.toFixed(3))

  const {
    showNoticeBannerHeight,
    showNavBanner

  } = useNoticeBanner(NoticeBarValues)

  const [showNav, setShowNav] = useState(NoticeBarValues)
  const [showBanner, setShowBanner] = useState(showNavBanner)
  const storeNavBannerSetting = () => {
    setShowBanner(false)
    updateNoticeBanner(NoticeBarValues.noticeVersion)
    NoticeBarValues.show = false
    NoticeBarValues.height = 0
    setShowNav(NoticeBarValues)
  }


  return (
    <>
      <NoticeBanner
        mainText={NoticeBarValues?.mainText}
        subText={NoticeBarValues?.subText}
        show={showBanner}
        height={showNoticeBannerHeight}
        noticeVersion={NoticeBarValues.noticeVersion}
        onStoreNav={storeNavBannerSetting}
      />
      <UikitMenu
        userMenu={<UserMenu/>}
        globalMenu={<GlobalSettings/>}
        isDark={isDark}
        toggleTheme={toggleTheme}
        currentLang={currentLanguage.code}
        langs={languageList}
        setLang={setLanguage}
        // cakePriceUsd={cakePriceNumber}
        links={config(t, account, appMode)}
        // magicLumPriceBox={<MenuPriceBox hide={!showMLUM} priceUsd={mlumPriceNumber} account={account} priceToken={magicLUM} iconTyp="mlum" />}
        // lumPriceBox={<MenuPriceBox hide={!showLUM} priceUsd={cakePriceNumber} account={account} priceToken={LUM} iconTyp="lum" />}
        // smrPriceBox={<MenuPriceBox hide={!showSMR || isXl} priceUsd={smrPriceNumber} account={account} priceToken={SMR} iconTyp="smr" />}
        // subLinks={activeMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
        footerLinks={footerLinks(t)}
        // activeItem={activeMenuItem?.href}
        // activeSubItem={activeSubMenuItem?.href}
        buyCakeLabel={t('Buy LUM')}
        networks={AVAILABLE_NETWORKS}
        chainId={chain?.id}
        switchNetwork={switchNetwork}
        showNetworkButton
        menuHeight={showNoticeBannerHeight}
        {...props}
      />
    </>
  )
}

export default Menu
